// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__lRohb","info":"Pagination_info__VWfD5","list":"Pagination_list__pj93v"};